<template>
<div class="time-source-chart-wrapper">
  <e-chart ref="chart" />
</div>
</template>

<script>
export default {
  name: 'TimeSourceChart',
  props: {
    dimensions: {
      required: true,
      type: Array
    },
    seriesMap: {
      required: true,
      type: Object
    }
  },
  methods: {
    renderChart () {
      const {dimensions, seriesMap} = this
      const chartOpt = {
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          left: 'center'
        },
        tooltip: {
          trigger: 'axis',
          appendToBody: true
        },
        grid: {
          top: 40,
          right: 30,
          bottom: 20,
          left: 30,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          nameLocation: 'center',
          data: dimensions.map(dimension => dimension.formatDataTime),
          splitLine: {
            show: false
          },
          axisLine: {
            onZero: false
          },
          axisLabel: {
            rotate: 90
          }
        },
        yAxis: [{
          type: 'value',
          name: `浓度`,
          splitLine: {
            show: false
          },
          axisLine: {
            show: true,
            onZero: false
          },
          axisTick: {
            show: true
          }
        }],
        series: [{
          name: '浓度趋势',
          type: 'line',
          data: seriesMap.contributions,
          color: seriesMap.color,
          showSymbol: false,
          yAxisIndex: 0
        }]
      }

      this.$refs.chart.setOpt(chartOpt, true)
    }
  },
  watch: {
    seriesMap () {
      this.renderChart()
    }
  },
  mounted () {
    setTimeout(() => {
      this.renderChart()
    }, 0)
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/11PMF-Analysis/01PM/01Run/TimeSourceChart.vue